import { Box, unstable_DropdownMenu as DropdownMenu, Text } from '@n26/nxd'
import { HeaderIconButton } from '@/shared/ui/HeaderIconButton'
import { useAuth } from './useAuth'

// A person glyph drawn in the same 18px, 1.5px-stroke style as the header's
// other icons (the design has no user button of its own).
const IconUser = () => (
  <svg viewBox='0 0 18 18' fill='currentColor' aria-hidden='true'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 1.5a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5ZM9 3a2.25 2.25 0 1 0 0 4.5A2.25 2.25 0 0 0 9 3Z'
    />
    <path d='M9 10.5c-3.87 0-7 2.46-7 5.5V17h1.5v-1c0-2.07 2.38-4 5.5-4s5.5 1.93 5.5 4v1H16v-1c0-3.04-3.13-5.5-7-5.5Z' />
  </svg>
)

export const ProfileMenu = () => {
  const { user, logout } = useAuth()

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <HeaderIconButton icon={<IconUser />} aria-label='Profile menu' />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='end'>
        <Box padding='12'>
          <Text as='div' variant='standard-bold'>
            {user?.name}
          </Text>
          {user?.email && (
            <Text as='div' variant='small' color='neutral'>
              {user.email}
            </Text>
          )}
        </Box>
        <DropdownMenu.Separator />
        <DropdownMenu.Item onClick={logout}>Log out</DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  )
}
